import { render, staticRenderFns } from "./PageManagedContracts.vue?vue&type=template&id=ddf08472&scoped=true&"
import script from "./PageManagedContracts.vue?vue&type=script&lang=js&"
export * from "./PageManagedContracts.vue?vue&type=script&lang=js&"
import style0 from "./PageManagedContracts.vue?vue&type=style&index=0&id=ddf08472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf08472",
  null
  
)

export default component.exports